module.exports = __webpack_public_path__ + "static/media/regal-rush-crown+logo-blue-bg-gold-400x240.194eae59.png";